<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">検索条件の保存</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body search-condition-save-dialog__body">
    <p class="search-condition-save-dialog__label">保存する名称を指定してください</p>
    <input
      type="text"
      class="search-condition-save-dialog__input"
      [(ngModel)]="name"
      placeholder="名称を入力してください"
    />
  </div>
  <div class="dialog__footer search-condition-save-dialog__footer">
    <button class="btn btn--small btn--gray" (click)="close()">
      キャンセル
    </button>
    <button
      class="btn btn--small btn--blue"
      [disabled]="!name.trim()"
      (click)="save()"
    >
      検索条件を保存する
    </button>
  </div>
</div>
